/* istanbul ignore file */
import { stringify } from 'query-string'
import {
  Entry,
  FDRStatsQueryItem,
  OrganizationContentModel,
  OrganizationItem,
  PaginationRequest,
  PaginationResponse,
} from '../types'
import { getMpAgent } from './utils'

const agent = getMpAgent()

const PATHS = {
  CONFIG: '/auth/config',
  ORGANIZATIONS: '/org/stats',
  SPONSOR_ORG_INFO: '/org/sponsor-info/:orgId',
}

export type OrganizationSortField =
  | 'orgName'
  | 'userCount'
  | 'registeredUserCount'
  | 'fieldCount'
  | 'committedFieldCount'

export interface OrganizationQuery extends Omit<PaginationRequest<object>, 'sort'> {
  sortField?: string
  sortDirection?: 'asc' | 'desc'
  // fdr sorting will override the top level sorting above
  fdrStats?: FDRStatsQueryItem[]
}

export interface ConfigResponse {
  content: Entry<OrganizationContentModel>
}

export class OrganizationAPI {
  static list(query?: OrganizationQuery) {
    const { sortDirection, sortField, ...params } = query || {}
    const sortParam =
      sortField && sortDirection ? { sortField: `${sortField}:${sortDirection}` } : undefined

    return agent
      .get<PaginationResponse<OrganizationItem>>(
        `${PATHS.ORGANIZATIONS}?${stringify({
          ...sortParam,
          ...params,
          fdrStats: !!query?.fdrStats ? JSON.stringify(query?.fdrStats) : undefined,
        })}`
      )
      .then(response => response?.data)
  }

  static config() {
    return agent.get<ConfigResponse>(PATHS.CONFIG).then(response => response?.data)
  }

  static sponsorInfo(orgId: string) {
    return agent
      .get<ConfigResponse>(PATHS.SPONSOR_ORG_INFO.replace(':orgId', orgId))
      .then(response => response?.data)
  }
}
